import { authenticate } from './api/geotab-client';
import { initDashboard } from './dashboard';
import { setDatabaseLabel } from './ui/topbar';

export function initStandalone(): void {
  const loginForm = document.getElementById('loginForm') as HTMLFormElement;

  loginForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const server   = (document.getElementById('server')   as HTMLInputElement).value;
    const database = (document.getElementById('database') as HTMLInputElement).value;
    const username = (document.getElementById('username') as HTMLInputElement).value;
    const password = (document.getElementById('password') as HTMLInputElement).value;
    const loginBtn = document.getElementById('loginBtn')   as HTMLButtonElement;
    const errorEl  = document.getElementById('loginError') as HTMLElement;

    loginBtn.disabled    = true;
    loginBtn.textContent = 'Connecting...';
    errorEl.classList.remove('show');

    try {
      await authenticate(server, database, username, password);

      setDatabaseLabel(database);
      document.getElementById('loginScreen')!.classList.add('hidden');
      document.getElementById('dashboardScreen')!.classList.remove('hidden');
      initDashboard(database);
    } catch (error) {
      errorEl.textContent = (error as Error).message;
      errorEl.classList.add('show');
      loginBtn.disabled    = false;
      loginBtn.textContent = 'Connect to Fleet';
    }
  });
}
